import { Region } from './region.enum.js';
export const ALLOWED_REGIONS = [Region.EU, Region.CA, Region.US];
export const DEFAULT_REGION = Region.EU;
